/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VoiceAgentProtocolEnum } from './VoiceAgentProtocolEnum';
import {
  VoiceAgentProtocolEnumFromJSON,
  VoiceAgentProtocolEnumFromJSONTyped,
  VoiceAgentProtocolEnumToJSON,
} from './VoiceAgentProtocolEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';

/**
 *
 * @export
 * @interface VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
 */
export interface VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina {
  /**
   *
   * @type {VoiceAgentProtocolEnum}
   * @memberof VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  protocol: VoiceAgentProtocolEnum;
  /**
   *
   * @type {number}
   * @memberof VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  name?: string | null;
  /**
   *
   * @type {CredentialRead}
   * @memberof VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  environment: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  domain?: string;
  /**
   *
   * @type {string}
   * @memberof VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  voice?: string;
  /**
   *
   * @type {number}
   * @memberof VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina
   */
  maxDuration?: number;
}

/**
 * Check if a given object implements the VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina interface.
 */
export function instanceOfVoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina(
  value: object,
): value is VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('environment' in value) || value['environment'] === undefined) return false;
  if (!('tenant' in value) || value['tenant'] === undefined) return false;
  return true;
}

export function VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaFromJSON(
  json: any,
): VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina {
  return VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaFromJSONTyped(json, false);
}

export function VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina {
  if (json == null) {
    return json;
  }
  return {
    protocol: VoiceAgentProtocolEnumFromJSON(json['protocol']),
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    environment: json['environment'],
    tenant: json['tenant'],
    region: json['region'] == null ? undefined : json['region'],
    domain: json['domain'] == null ? undefined : json['domain'],
    voice: json['voice'] == null ? undefined : json['voice'],
    maxDuration: json['max_duration'] == null ? undefined : json['max_duration'],
  };
}

export function VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaToJSON(
  value?: Omit<VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina, 'id' | 'credential'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: VoiceAgentProtocolEnumToJSON(value['protocol']),
    name: value['name'],
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    environment: value['environment'],
    tenant: value['tenant'],
    region: value['region'],
    domain: value['domain'],
    voice: value['voice'],
    max_duration: value['maxDuration'],
  };
}
